import { FlexBox } from "@brg/ui";
import { ShopImage } from "shared/pages/Shop/ShopCard";
import styled, { css } from "styled-components";

export const GoodsWrapper = styled(FlexBox)`
    width: 100%;
    flex-flow: column;
`;

export const GoodItem = styled(FlexBox)`
    min-height: 52px;
    max-height: 64px;
    margin-bottom: 24px;
    // background-color: ${({ theme }) => theme.projectEdit.inputs.bg};
    position: relative;
    padding: 8px 12px;
    justify-content: space-between;
    flex-flow: row;
    border-radius: 4px;
    align-items: center;
`;

export const ItemNameWrapper = styled(FlexBox)`
    gap: 12px;
    align-items: center;
    max-height: 100%;
`

export const TitleWrapper = styled(FlexBox)`
    max-width: 250px;
`;

export const Title = styled.div`
    font-size: 15px;
    line-height: 20px;
    color: ${({ theme }) => theme.projectEdit.mobile.buttons.color};
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 8px;
    cursor: pointer;
    max-width: 190px;
    white-space: nowrap;
`


export const ActionWrapper = styled(FlexBox)`
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.projectEdit.label};
    cursor: pointer;
    gap: 16px;
`;
export const GoodsDescription = styled.div`
   color: ${({ theme }) => theme.projectEdit.label};
   font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
`;

export const ArrowWrapper = styled(FlexBox)<{ isOpen: boolean }>`
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.2s;
  cursor: pointer;

  svg path {
    fill: #909090;
  }

  ${({ isOpen }) => isOpen && css`
    transform: rotate(180deg) translateY(-35%);
    top: 35%;
    transition: transform 0.2s;
  `};
`;
export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.projectEdit.label};
  margin: 8px 0;
`;


export const Price = styled.div`
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    font-weight: 600;
    white-space: nowrap;
`;

export const SmallImage = styled(ShopImage)`
    height: 48px !important;
    min-height: auto !important;
    max-height: 64px !important;
    // width: 55px !important;
    width: auto;
    border-radius: 2px;
    box-shadow: none;
    background: inherit;
    img {
        object-position: center;
    }
`;

export const ImageWrapper = styled.div`
    // position: absolute;
    // bottom: 0;
    // right: 52px;
    height: 48px;
    width: 48px;
    background: #E7E7E7;
    border-radius: 3px;
`;import { FlexBox } from "@brg/ui";
import { ShopImage } from "shared/pages/Shop/ShopCard";
import styled, { css } from "styled-components";

export const GoodsWrapper = styled(FlexBox)`
    width: 100%;
    flex-flow: column;
`;

export const GoodItem = styled(FlexBox)`
    min-height: 52px;
    max-height: 64px;
    margin-bottom: 24px;
    // background-color: ${({ theme }) => theme.projectEdit.inputs.bg};
    position: relative;
    padding: 8px 12px;
    justify-content: space-between;
    flex-flow: row;
    border-radius: 4px;
    align-items: center;
`;

export const ItemNameWrapper = styled(FlexBox)`
    gap: 12px;
    align-items: center;
    max-height: 100%;
`

export const TitleWrapper = styled(FlexBox)`
    max-width: 250px;
`;

export const Title = styled.div`
    font-size: 15px;
    line-height: 20px;
    color: ${({ theme }) => theme.projectEdit.mobile.buttons.color};
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 8px;
    cursor: pointer;
    max-width: 190px;
    white-space: nowrap;
`


export const ActionWrapper = styled(FlexBox)`
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.projectEdit.label};
    cursor: pointer;
    gap: 16px;
`;
export const GoodsDescription = styled.div`
   color: ${({ theme }) => theme.projectEdit.label};
   font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.3px;
`;

export const ArrowWrapper = styled(FlexBox)<{ isOpen: boolean }>`
  position: absolute;
  right: 0px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.2s;
  cursor: pointer;

  svg path {
    fill: #909090;
  }

  ${({ isOpen }) => isOpen && css`
    transform: rotate(180deg) translateY(-35%);
    top: 35%;
    transition: transform 0.2s;
  `};
`;
export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.projectEdit.label};
  margin: 8px 0;
`;


export const Price = styled.div`
    font-size: 13px;
    line-height: 16px;
    color: #909090;
    font-weight: 600;
    white-space: nowrap;
`;

export const SmallImage = styled(ShopImage)`
    height: 48px !important;
    min-height: auto !important;
    max-height: 64px !important;
    // width: 55px !important;
    width: auto;
    border-radius: 2px;
    box-shadow: none;
    background: inherit;
    img {
        object-position: center;
    }
`;

export const ImageWrapper = styled.div`
    // position: absolute;
    // bottom: 0;
    // right: 52px;
    height: 48px;
    width: 48px;
    background: #E7E7E7;
    border-radius: 3px;
`;